import { Component, Input, OnDestroy, OnInit } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import 'rxjs/add/operator/do'
import { fuseAnimations } from '../../../../../core/animations'
import { BillingSubscriptionModel } from '../../../../models/billing/billing-subscription-model'
import { BillingTrialModel } from '../../../../models/billing/billing-trial-model'
import { AdministrationModel } from '../../../../models/administration.model'
import { BillingService } from '../../../../services/billing.service'
import { Subscription } from 'rxjs/Subscription'


@Component({
  selector: 'app-billing-details',
  templateUrl: './billing-details.component.html',
  styleUrls: ['./billing-details.component.scss'],
  animations: fuseAnimations,
})
export class BillingDetailsComponent implements OnInit, OnDestroy {
  @Input() administration: AdministrationModel

  isLoading = true
  billing: BillingSubscriptionModel | BillingTrialModel
  onBillingChange: Subscription

  /**
   * Constructor.
   *
   * @param _route
   * @param _billingService
   * @param _router
   */
  constructor(private _route: ActivatedRoute, private _billingService: BillingService, private _router: Router) {
    this.billing = this._route.snapshot.params['billing']
  }

  /**
   * Destroy lifecycle method.
   */
  ngOnDestroy(): void {
    this.isLoading = false
  }

  /**
   * Init lifecycle method.
   */
  ngOnInit(): void {
    if (this.billing === undefined) {
      this._billingService
        .fetchByAdministration(this.administration)
        .subscribe(billingModel => {
          this.isLoading = false
          this.billing = billingModel
        })
    }

    this.onBillingChange = this._billingService.obBillingChanged
      .subscribe((billing: BillingSubscriptionModel | BillingTrialModel) => {
        this.billing = billing
      })
  }
}



// WEBPACK FOOTER //
// ./src/app/main/content/administrations/administration-details/billing/billing-details.component.ts